import { ComponentProps } from 'react';

export function ContactUs({ ...props }: ComponentProps<'svg'>) {
  return (
    <svg
      {...props}
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 5.5C13 2.4625 10.0906 0 6.5 0C2.90937 0 0 2.4625 0 5.5C0 6.80094 0.536875 7.99406 1.42906 8.93437C0.918437 9.91656 0.226875 10.6709 0.210625 10.6831C-0.000187501 10.9066 -0.0592187 11.2397 0.0630938 11.5262C0.185313 11.8156 0.467813 12 0.779688 12C2.47281 12 3.85219 11.3988 4.78281 10.8056C5.35 10.9281 5.91563 11 6.5 11C10.0906 11 13 8.5375 13 5.5ZM6.5 9.5C6.0575 9.5 5.60094 9.44722 5.14344 9.34309L4.54375 9.20625L4.02125 9.52969C3.49 9.85844 2.94563 10.1044 2.39188 10.2662C2.52262 10.0579 2.64784 9.84219 2.75969 9.62719L3.25281 8.67906L2.51781 7.90312C2.05344 7.41562 1.5 6.6 1.5 5.5C1.5 3.29437 3.74312 1.5 6.5 1.5C9.25688 1.5 11.5 3.29437 11.5 5.5C11.5 7.70563 9.25625 9.5 6.5 9.5ZM18.7375 13.8656C19.525 12.9344 20 11.7688 20 10.5C20 7.4625 17.3125 5 14 5C13.9902 5 13.9807 5.00128 13.9708 5.00134C13.9844 5.16563 14 5.33125 14 5.5C14 8.58187 11.51 11.1625 8.18437 11.8281C8.83437 14.2219 11.1594 16 14 16C15.0528 16 16.0412 15.7498 16.9016 15.3131C17.6625 15.6875 18.6281 16 19.7594 16C19.855 16 19.9394 15.9461 19.9788 15.8561C20.0172 15.7661 19.9993 15.664 19.9337 15.595C19.925 15.5844 19.2469 14.8531 18.7375 13.8656Z"
        fill="currentColor"
      />
    </svg>
  );
}
